import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    galleryViewConnectedUser: [],
    pinForScreenShare: false,
};

const galleryViewReducerSlice = createSlice({
    name: "galleryViewReducer",
    initialState,
    reducers: {
        setGalleryViewConnectedUser(state, action) {
            state.galleryViewConnectedUser = action.payload;
        },
        setPinForScreenShare(state, action) {
            state.pinForScreenShare = action.payload;
        },
        resetGalleryViewReducer() {
            return initialState;
        },
    },
});

export const { setGalleryViewConnectedUser, setPinForScreenShare, resetGalleryViewReducer } = galleryViewReducerSlice.actions;
export default galleryViewReducerSlice.reducer;
